import useMountEffect from '@restart/hooks/useMountEffect';
import { useState } from 'react';
import { useDispatch } from 'react-redux';

import actions from '@/actions';
import EventEmitter from '@/libs/EventEmitter';

const useWaitingRobot = (robotId) => {
  const dispatch = useDispatch();
  const [isWaiting, setIsWaiting] = useState(true);

  useMountEffect(() => {
    EventEmitter.subscribe(`${robotId}/event/waitingRobot`, () => {
      setIsWaiting(true);
    });

    EventEmitter.subscribe(`${robotId}/event/reconnectRobot`, () => {
      setIsWaiting(false);
    });

    EventEmitter.subscribe(`${robotId}/event/disconnectRobot`, () => {
      dispatch(actions.missions.unload(robotId));
      dispatch(actions.notifications.remove(robotId));
      dispatch(actions.robotOptions.remove(robotId));
      dispatch(actions.robotParams.remove(robotId));
      dispatch(actions.robots.deactivate(robotId));
      dispatch(actions.telemetry.remove(robotId));
    });
  });

  return isWaiting;
};

export default useWaitingRobot;
